/* eslint-disable tailwindcss/no-arbitrary-value */
import classNames from 'classnames';
import { HTMLAttributes, PropsWithChildren } from 'react';

type PageContentContainerProps = PropsWithChildren<
  HTMLAttributes<HTMLDivElement>
>;

export type PageContentContainerType = typeof PageContentContainer;

export const PageContentContainer = ({
  children,
  className,
  ...other
}: PageContentContainerProps) => {
  return (
    <div
      className={classNames('w-full px-spacing/padding/section-x', className)}
      {...other}
    >
      <div
        className={classNames(
          'max-w-[--breakpoints-content-narrow-3-lg] lg:mx-auto',
        )}
      >
        {children}
      </div>
    </div>
  );
};
